(function($, console) {
$(document).ready(function() {

// Hack to hide iOS toolbars
window.scrollTo(0, 1);

// Cache elements
var $$ = {};
$$.html = $('html');
$$.body = $('body');
$$.page = $$.html.add($$.body);
$$.app = $('.app');
$$.run = $('.run');
$$.hr = $('hr');
$$.message = $('.message');
$$.groups = $('.groups');

// App preferences
var app = {};
// Paths
app.path = {};
app.path.resources = '/unscrambler/resources';
app.path.dictionary = app.path.resources + '/dictionary/dictionary.json';
app.path.trie = app.path.resources + '/scripts/boggle-solver/trie.min.js';
app.path.boggle = app.path.resources + '/scripts/boggle-solver/boggle.min.js';
// State
app.ready = false;
app.running = false;
app.data = {};
app.worker = null;
// Browser support for certain features
app.supports = {
	workers: (window.Worker !== undefined),
	touch: (window.ontouchstart !== undefined)
};
// Parameters
app.prefs = {
	minLetters: 3,
	maxLetters: 26,
	pointValues: {
		a: 1,
		b: 4,
		c: 4,
		d: 2,
		e: 1,
		f: 4,
		g: 3,
		h: 3,
		i: 1,
		j: 10,
		k: 5,
		l: 2,
		m: 4,
		n: 2,
		o: 1,
		p: 4,
		q: 10,
		r: 1,
		s: 1,
		t: 1,
		u: 2,
		v: 5,
		w: 4,
		x: 8,
		y: 3,
		z: 10
	}
};

// Remove duplicates from the given word list
function removeDuplicates(words) {
	var unique,
		word, w;
	// Create an empty list for storing unique words
	unique = [];

	// Loop through every word in the given word list
	for (w = 0; w < words.length; w += 1) {
		word = words[w];
		// If this instance of word is first instance
		if ($.inArray(word, words) === w) {
			// Add word to list of unique words
			unique.push(word);
		}
	}
	return unique;
}

// Get number of points for this word
function getPoints(word) {
	var points, letter, l;

	// Store total number of points for this word
	points = 0;

	// Loop through letters in word
	for (l = 0; l < word.length; l += 1) {

		letter = word[l];
		// Add letter's point value to sum
		points += app.prefs.pointValues[letter];

	}
	return points;
}

// Format the given word
function formatWord(word) {
	word = word.toLowerCase();
	word = word.replace(/\*/gi, 'qu');
	return word;
}

// Sort the given word list using the given parameters
function groupWords(params) {
	var word, w,
		group, value;

	// Clone word list
	params.words = params.words.slice(0);

	// Remove duplicates
	params.words = removeDuplicates(params.words);

	// Create map for easy retrieval of word groups
	params.groupMap = {};
	// Keep all word groups ordered in a list
	params.groups = [];

	// Loop through list of words
	for (w = 0; w < params.words.length; w += 1) {

		word = params.words[w];
		word = formatWord(word);

		// Get value used to determine placement of word
		value = params.groupBy(word);

		// If group doesn't exist
		if (params.groupMap[value] === undefined) {
			// Create new group
			group = {
				value: value,
				words: []
			};
			// Add group to ordered list
			params.groups.push(group);
			// Store reference to group in map
			params.groupMap[value] = group;
		} else {
			group = params.groupMap[value];
		}
		// Add word to group
		group.words.push(word);

	}

	// Delete properties to save memory
	delete params.groupMap;

	// Sort list of groups
	params.groups.sort(function(group1, group2) {
		return (group1.value - group2.value);
	});

	if (params.descending) {
		// Optionally sort groups in descending order
		params.groups.reverse();
	}

	return params;
}

// Predefined grouping configurations

function groupWordsByPoints(words) {
	return groupWords({
		words: words,
		type: 'points',
		descending: true,
		groupBy: function(word) {
			return getPoints(word);
		}
	});
}

function groupWordsByLength(words) {
	return groupWords({
		words: words,
		type: 'letters',
		descending: true,
		groupBy: function(word) {
			return word.length;
		}
	});
}

// Display word list possibilities
function displayWords(words) {
	var params,
		groups, group, g,
		word, w, units,
		$heading, $group, anchorList;

	// Determine how to group words
	if (app.id === 'unboggler') {
		params = groupWordsByPoints(words);
	} else {
		params = groupWordsByLength(words);
	}

	// Cache groups property for convenience
	groups = params.groups;

	// Word sorting function
	function comparisonFunction(word1, word2) {
		word1 = word1.toLowerCase();
		word2 = word2.toLowerCase();
		if (word1 < word2) {
			return -1;
		} else if (word1 > word2) {
			return 1;
		}
	}

	// Display each group
	for (g = 0; g < groups.length; g += 1) {

		group = groups[g];
		words = group.words;

		// Do not display empty groups
		if (words.length !== 0) {

			// Handle pluralization
			if (group.words.length === 1) {
				units = 'word';
			} else {
				units = 'words';
			}

			// Create and insert group heading
			$heading = $("<h2>" + group.value + " " + params.type + "</h2>");
			$heading.append("<span class='word count'>" + words.length + " " + units + "</span>");
			$heading.appendTo($$.groups);

			// Create paragraph container for word group
			$group = $("<p class='group'></p>");

			// Create list for anchor element HTML
			anchorList = [];

			// Sort word list alphabetically
			words.sort(comparisonFunction);

			// Link each word to its definition
			for (w = 0; w < words.length; w += 1) {

				word = words[w];
				anchorList.push("<a href='https://www.google.com/search?q=define+" + word + "' target='_blank' rel='noopener'>" + word + "</a>");

			}
			// Add words to word list element
			$group.append(anchorList.join(', '));
			$group.appendTo($$.groups);

		}

	}

	// Handle pluralization
	if (params.words.length === 1) {
		units = 'word';
	} else {
		units = 'words';
	}
	// Display total number of matching words
	$$.message.html(params.words.length + ' ' + units + ' found.');
	// Scroll to list of matching words using animation
	$$.page.animate({
		scrollTop: $$.hr.offset().top
	}, 500);
}

// Display the message of the given type
function displayMessage(message) {
	// Display the determined message
	$$.message.html(message);
}

// Show or hide status controls

// Code to run when solver starts the first cycle
function start() {
	// Run setup code before solver runs
	app.running = true;
	// Clear message and unscrambled word list
	$$.message.empty();
	$$.groups.empty();
	// Display loading throbber and controls
	$$.message.html('Running...');
	$$.app.addClass('running');
}

// Code to run when all solver cycles complete
function end(event) {
	if (event.data.log === true) {
		console.log(event.data.data);
	} else {
		$$.app.removeClass('running');
		displayWords(event.data.words);
	}
	app.running = false;
}

// Click "Run" button to unscramble word
$$.run.on('click', function() {
	app.run();
});

// Load dictionary file
$.getJSON(app.path.dictionary, function(words) {
	app.dictionary = words;
	app.ready = true;
	displayMessage('Ready');
});

// Export helper functions
window.$$ = $$;
window.app = app;
app.displayMessage = displayMessage;
app.start = start;
app.end = end;

});
}(jQuery, window.console));
